<template>
  <n-icon
    @click="$emit('click', $event)"
    :size="size"
    :component="importedIcon"
    :class="{
      'opacity-50 pointer-events-none': disabled
    }"
  />
</template>

<script>
import {
  FileCopyRound,
  MenuRound,
  PhotoCameraOutlined,
  HistoryFilled,
  QrCodeScannerFilled,
  CloseFilled,
  CloseRound,
  PersonFilled,
  PersonAddFilled,
  ArrowBackRound,
  KeyboardArrowLeftRound,
  KeyboardArrowUpRound,
  ArrowForwardIosRound,
  ArrowForwardRound,
  ArrowBackIosRound,
  CardGiftcardRound,
  CreditCardRound,
  MinusRound,
  PlusRound,
  SearchOffFilled,
  PersonOffRound,
  HomeRound,
  HomeOutlined,
  LocationOnFilled,
  SettingsRound,
  SupervisorAccountRound,
  ColorLensRound,
  DiscountRound,
  LibraryBooksRound,
  LocationCityRound,
  StoreOutlined,
  AccountCircleRound,
  CoffeeFilled,
  EditRound,
  CheckRound,
  CheckCircleRound,
  RadioButtonUncheckedRound,
  LanguageRound,
  AppleRound,
  AndroidRound,
  MessageRound,
  InfoOutlined,
  InfoRound,
  DeleteFilled,
  DeleteOutlined,
  BackspaceOutlined,
  StarFilled,
  StarBorderFilled,
  OpenInNewFilled,
  SearchFilled,
  KeyboardArrowDownRound,
  KeyboardArrowDownOutlined,
  EmailOutlined,
  SmsOutlined,
  SmsRound,
  SmartphoneRound,
  LaptopRound,
  NotificationsNoneOutlined,
  FileUploadOutlined,
  AccountTreeRound,
  AccountTreeOutlined,
  KeyboardDoubleArrowRightRound,
  EmailFilled,
  CampaignRound,
  CakeRound,
  StarRound,
  SnoozeRound,
  PersonAddAlt1Round,
  InboxTwotone,
  AddLocationAltRound,
  DisplaySettingsRound,
  KeyboardAltFilled,
  FileDownloadOutlined,
  TrendingUpRound,
  WhatsappFilled,
  QrCode2Filled,
  ContentCopyOutlined,
  ContentCopyRound,
  FilterAltOutlined,
  FilterAltOffOutlined,
  HourglassTopFilled,
  CompareArrowsRound,
  ShoppingBagOutlined,
  DocumentScannerRound,
  EventFilled,
  GroupAddRound,
  PowerSettingsNewRound,
  ManageAccountsFilled,
  PercentRound,
  SendRound,
  PersonAddRound,
  WebRound,
  ShareRound,
  BlockRound,
  RestaurantRound,
  DoneAllRound,
  Md123Round,
  ExposurePlus1Round,
  LocalPhoneOutlined,
  CalendarMonthRound,
  BeachAccessRound,
  EventAvailableRound,
  EventBusyRound,
  AccountBalanceWalletOutlined,
  AutorenewOutlined,
  DiscountOutlined,
  CakeOutlined,
  InstallMobileOutlined,
  CampaignOutlined,
  SourceOutlined,
  SettingsOutlined,
  AmpStoriesOutlined,
  BoltRound,
  StarBorderRound,
  VideogameAssetRound,
  EmojiPeopleRound,
  AutoAwesomeRound,
  StickyNote2Outlined,
  AttachMoneyRound,
  MoneyRound,
  SyncAltRound,
  BarChartRound,
  WarningRound,
  SubdirectoryArrowRightRound,
  RemoveRedEyeRound,
  NotificationsFilled,
  ReceiptRound,
  EmojiEventsRound,
  CelebrationRound,
  PendingRound,
  AccountBalanceWalletRound,
  DataObjectRound
} from '@vicons/material'
import { h } from 'vue'

const InstagramFilled = {
  render() {
    return h('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 1024 1024' }, [
      h('path', { d: 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3S645.3 585.4 645.3 512S585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165c-3.1-64-17.7-120.8-64.5-167.6c-46.9-46.9-103.6-61.4-167.6-64.5c-55.2-3.1-109.9-2.6-165-2.6c-55.2 0-109.9-.5-165 2.6c-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6c46.9 46.9 103.6 61.4 167.6 64.5c55.2 3.1 109.9 2.6 165 2.6c55.2 0 109.9.5 165-2.6c64-3.1 120.8-17.7 167.6-64.5c46.9-46.9 61.4-103.6 64.5-167.6c3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9S717.1 398.5 717.1 512S625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9s47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z', fill: 'currentColor' })
    ])
  }
}

const TiktokFilled = {
  render() {
    return h('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 448 512' }, [
      h('path', { d: 'M448 209.9a210.1 210.1 0 0 1-122.8-39.3v178.7A162.6 162.6 0 1 1 185.1 188.2v89.9a74.6 74.6 0 1 0 52.2 71.2V0h88a121.2 121.2 0 0 0 1.9 22.2A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z', fill: 'currentColor' })
    ])
  }
}

const WhatsAppCustom = {
  render() {
    return h('svg', { xmlns: 'http://www.w3.org/2000/svg', viewBox: '0 0 512 512' }, [
      h('path', { d: 'M260.062,32C138.605,32,40.134,129.701,40.134,250.232c0,41.23,11.532,79.79,31.559,112.687L32,480l121.764-38.682c31.508,17.285,67.745,27.146,106.298,27.146C381.535,468.464,480,370.749,480,250.232C480,129.701,381.535,32,260.062,32z M369.424,333.11c-5.174,12.827-28.574,24.533-38.899,25.072c-10.314,0.547-10.608,7.994-66.84-16.434c-56.225-24.434-90.052-83.844-92.719-87.67c-2.669-3.812-21.78-31.047-20.749-58.455c1.038-27.413,16.047-40.346,21.404-45.725c5.351-5.387,11.486-6.352,15.232-6.413c4.428-0.072,7.296-0.132,10.573-0.011c3.274,0.124,8.192-0.685,12.45,10.639c4.256,11.323,14.443,39.153,15.746,41.989c1.302,2.839,2.108,6.126,0.102,9.771c-2.012,3.653-3.042,5.935-5.961,9.083c-2.935,3.148-6.174,7.042-8.792,9.449c-2.92,2.665-5.97,5.572-2.9,11.269c3.068,5.693,13.653,24.356,29.779,39.736c20.725,19.771,38.598,26.329,44.098,29.317c5.515,3.004,8.806,2.67,12.226-0.929c3.404-3.599,14.639-15.746,18.596-21.169c3.955-5.438,7.661-4.373,12.742-2.329c5.078,2.052,32.157,16.556,37.673,19.551c5.51,2.989,9.193,4.529,10.51,6.9C375.012,309.131,374.596,320.282,369.424,333.11z', fill: 'currentColor' })
    ])
  }
}

const iconMap = {
  FileCopyRound,
  MenuRound,
  PhotoCameraOutlined,
  InstagramFilled,
  TiktokFilled,
  WhatsAppCustom,
  HistoryFilled,
  QrCodeScannerFilled,
  CloseFilled,
  CloseRound,
  PersonFilled,
  PersonAddFilled,
  ArrowBackRound,
  ArrowForwardIosRound,
  ArrowForwardRound,
  ArrowBackIosRound,
  KeyboardArrowLeftRound,
  CardGiftcardRound,
  CreditCardRound,
  MinusRound,
  PlusRound,
  LocationOnFilled,
  SearchOffFilled,
  SearchFilled,
  CheckCircleRound,
  RadioButtonUncheckedRound,
  SmartphoneRound,
  LaptopRound,
  HomeRound,
  HomeOutlined,
  SettingsRound,
  SupervisorAccountRound,
  ColorLensRound,
  DiscountRound,
  LibraryBooksRound,
  LocationCityRound,
  StoreOutlined,
  AccountCircleRound,
  CoffeeFilled,
  EditRound,
  CheckRound,
  LanguageRound,
  AppleRound,
  AndroidRound,
  MessageRound,
  InfoOutlined,
  InfoRound,
  DeleteFilled,
  DeleteOutlined,
  BackspaceOutlined,
  StarFilled,
  StarBorderFilled,
  OpenInNewFilled,
  KeyboardArrowDownRound,
  KeyboardArrowUpRound,
  KeyboardArrowDownOutlined,
  EmailOutlined,
  SmsOutlined,
  SmsRound,
  NotificationsNoneOutlined,
  FileUploadOutlined,
  AccountTreeRound,
  AccountTreeOutlined,
  KeyboardDoubleArrowRightRound,
  EmailFilled,
  CampaignRound,
  CakeRound,
  StarRound,
  StarBorderRound,
  SnoozeRound,
  PersonAddAlt1Round,
  PersonOffRound,
  InboxTwotone,
  AddLocationAltRound,
  DisplaySettingsRound,
  KeyboardAltFilled,
  FileDownloadOutlined,
  TrendingUpRound,
  WhatsappFilled,
  QrCode2Filled,
  ContentCopyOutlined,
  ContentCopyRound,
  FilterAltOutlined,
  FilterAltOffOutlined,
  HourglassTopFilled,
  CompareArrowsRound,
  ShoppingBagOutlined,
  DocumentScannerRound,
  EventFilled,
  GroupAddRound,
  PowerSettingsNewRound,
  ManageAccountsFilled,
  PercentRound,
  SendRound,
  PersonAddRound,
  WebRound,
  ShareRound,
  BlockRound,
  RestaurantRound,
  DoneAllRound,
  Md123Round,
  ExposurePlus1Round,
  LocalPhoneOutlined,
  CalendarMonthRound,
  BeachAccessRound,
  EventAvailableRound,
  EventBusyRound,
  AccountBalanceWalletOutlined,
  AutorenewOutlined,
  DiscountOutlined,
  CakeOutlined,
  InstallMobileOutlined,
  CampaignOutlined,
  SourceOutlined,
  SettingsOutlined,
  AmpStoriesOutlined,
  BoltRound,
  VideogameAssetRound,
  EmojiPeopleRound,
  AutoAwesomeRound,
  StickyNote2Outlined,
  AttachMoneyRound,
  MoneyRound,
  SyncAltRound,
  BarChartRound,
  WarningRound,
  SubdirectoryArrowRightRound,
  RemoveRedEyeRound,
  NotificationsFilled,
  ReceiptRound,
  EmojiEventsRound,
  CelebrationRound,
  PendingRound,
  AccountBalanceWalletRound,
  DataObjectRound
}

export default {
  name: 'CIcon',
  props: {
    small: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: '1.5rem'
    },
    name: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    originalColor: {
      type: Boolean,
      default: false
    },
    svgType: {
      type: String,
      default: 'fill',
      validator: function (value) {
        // The value must match one of these strings
        return ['fill', 'stroke'].indexOf(value) !== -1
      }
    }
  },
  emits: ['click'],
  computed: {
    importedIcon() {
      return iconMap[this.name]
    }
  }
}
</script>

<style>
.current-color-stroke path {
  stroke: currentColor;
}
.current-color-fill path {
  fill: currentColor;
}
svg {
  display: block;
  width: 100%;
  height: 100%;
}
</style>
